import { makeAutoObservable, observable } from "mobx";
import targetingPermissions from '../permissions/targeting.json'
import changeRequestsPermissions from '../permissions/changeRequests.json'

export default class PermissionsStore {

    constructor(rootStore) {
        this.rootStore = rootStore;
        makeAutoObservable(this, { permissions: observable });
    }

    permissions = { ...targetingPermissions, ...changeRequestsPermissions };
}